import { PageWrapper } from '../components/design-system/PageWrapper';
import { Navigation } from '../components/Navigation';
import { CONTENT_MAX_WIDTH } from '../constants';
import { usePageMeta } from '../hooks/usePageMeta';

export const PrivacyPolicy = () => {
  usePageMeta({
    title: 'Privacy Policy - CardClues',
    description:
      'CardClues privacy policy. Learn how we handle your data when you use our credit card comparison tool.',
    canonicalPath: '/privacy-policy',
  });
  return (
    <div>
      <Navigation />
      <PageWrapper
        contentWrapperStyle={{
          paddingBottom: 100,
          maxWidth: CONTENT_MAX_WIDTH,
        }}
      >
        <h1>Privacy Policy</h1>
        <p style={{ fontSize: '12px' }}>Last updated: November 2025</p>
        <p style={{ fontSize: '12px' }}>
          CardClues ("we," "our," or "us") values your privacy. This site
          provides general information about credit cards and related products.
        </p>
        <h3>Information We Collect</h3>
        <p style={{ fontSize: '12px' }}>
          We may collect limited, non-personal information about how visitors
          use our site—such as device type, browser, and general usage
          patterns—so we can maintain and improve performance.
        </p>
        <h3>How We Use Information</h3>
        <p style={{ fontSize: '12px' }}>
          This information helps us operate the site securely, understand
          traffic trends, and enhance the user experience. We don't collect
          personal details like your name or contact information, and we don't
          sell or share data for advertising purposes.
        </p>
        <h3>Analytics & Security</h3>
        <p style={{ fontSize: '12px' }}>
          We use trusted partners, including Google Analytics and Cloudflare, to
          analyze traffic and protect against abuse. These providers process
          data in line with their own privacy policies.
        </p>
        <p style={{ fontSize: '12px' }}>
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4DA9E6' }}
          >
            Google Privacy & Terms
          </a>
        </p>
        <p style={{ fontSize: '12px' }}>
          <a
            href="https://www.cloudflare.com/privacypolicy/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4DA9E6' }}
          >
            Cloudflare Privacy Policy
          </a>
        </p>
        <h3>Your Choices</h3>
        <p style={{ fontSize: '12px' }}>
          You can adjust your browser settings to block cookies or limit
          tracking if you prefer.
        </p>
        <h3>Contact</h3>
        <p style={{ fontSize: '12px' }}>
          Questions? Email{' '}
          <a href="mailto:hello@cardclues.com" style={{ color: '#4DA9E6' }}>
            hello@cardclues.com
          </a>
        </p>
      </PageWrapper>
    </div>
  );
};
